  <template >
   <div class="formPosition" v-role="roles">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

              <h4 style="text-align:center;"> <span> Filtragem dos Dados - Pesquisa Local</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">
       <v-col class="d-flex" cols="3" sm="2">

        <v-select
          v-model="select1"
          :items="items1"
          :rules="ruleRequired"
          @change="SelecionaEntidade()"
          label="Selecione a entidade"
        ></v-select>

      </v-col>
      <v-col class="d-flex" cols="4" sm="2">
         <v-select v-if="select1 !== null "
          v-model="select_anolectivo"
          :items="ano"
          :rules="ruleRequired"
          :disabled="disabilita_ano"
          @change="CarregaAlunos()"
          label="Anolectivo"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="3" sm="3">
          <v-combobox v-if="estudante"
                    v-model="pesquisa_parameto"
                    :rules="ruleRequired"
                    item-value="nome"
                    item-text="nome"
                    :items="Pessoas"
                    :disabled="!Pessoas.length"
                    @change="SelecionaAluno()"
                    label="Selecione o estudante"
            ></v-combobox>

            <v-combobox v-if="!estudante"
                    v-model="pesquisa_parameto"
                    :rules="ruleRequired"
                    item-value="nome"
                    item-text="nome"
                    :items="funcionarios"
                    @change="SelecionaAluno()"
                    label="Selecione o funcionário"
            ></v-combobox>
      </v-col>

        <v-col class="d-flex" cols="4" sm="2">

        <v-progress-circular
        v-if="progresso"
        indeterminate
        color="green"
    ></v-progress-circular>
      </v-col>
      <v-col class="d-flex" cols="3" sm="3">
         <label style="color:red" v-if="( select1 !== null && select_anolectivo !== null && !Pessoas.length && progresso === false)">Não existe dado neste ano</label>
      </v-col >
    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.idMatricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Genero:<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.sexo):''}}</strong></v-chip>
     </v-col>
     <v-col md="8">
          <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.datanascimento):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Natural de :<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">BI:<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.bi):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Filho de :<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">e De:<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.nomedamae):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="12">
          <v-chip style="margin:4px">Contacto:<strong>{{(this.pesquisa_parameto !== null)?(this.pesquisa_parameto.telefone):''}}</strong></v-chip>
     </v-col>
    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table v-if="estudante"
            :headers="headers"
            :items="estudante_dados"
          >

      </v-data-table>

  </v-col>
</v-row>
  </v-card>

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    roles: 'func',
    select2: null,
    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    disabilita_ano: true,
    funcionarios: [],
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'idAno_Academico' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // check if classe has been selected otherwise send back to painel to select

  },
  methods: {

    SelecionaEntidade () {
      if (this.select1 !== 'Aluno') {
        this.estudante = false
        this.disabilita_ano = true
        this.CarregaFuncionario()
      } else {
        this.disabilita_ano = false
        this.estudante = true
      }
    },

    async CarregaAlunos () {
      if (this.select_anolectivo != null) {
        try {
          this.progresso = true
          this.Pessoas = await axios
            .get('/pessoaFind/' + this.select_anolectivo)
            .then(res => res.data)
          this.progresso = false
          console.log(this.Pessoas)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async SelecionaAluno () {
      if (this.pesquisa_parameto != null) {
        // CarregaInscrição na turma
        try {
          this.estudante_dados = await axios
            .get('/InscricaoTurma/' + this.pesquisa_parameto.idMatricula)
            .then(res => res.data)
          console.log(this.estudante_dados)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async CarregaFuncionario () {
      let payload = '{"find":"all"}'
      try {
        this.funcionarios = await axios
          .get('/funcionarioPessoaFindAll/' + payload)
          .then(res => res.data)
        console.log(this.funcionarios)
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
